import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { type GetMessagesResponse, MessagesApi } from '@shared/api/rest';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface IMessagesStore {
  loading: boolean;
  error: string | null;
  messages: GetMessagesResponse[];
  getMessages: (type: 'incomming' | 'outgoing', signal?: AbortSignal) => Promise<void>;
  readMessage: (messageId: string) => void;
  clear: () => void;
}

export const useMessagesStore = create<IMessagesStore>((set, get) => ({
  loading: false,
  error: null,
  messages: [],

  getMessages: ApiUtils.wrapperApi(async (type, signal) => {
    try {
      set({ loading: true, error: null, messages: [] });
      const result = await MessagesApi.getMessages(type, signal);
      set({ messages: result.data ?? [], loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  readMessage: (messageId: string) =>
    set({
      messages: get().messages.map((message) => {
        if (message.Id === messageId) return { ...message, UnreadFlag: false };
        return message;
      }),
    }),

  clear: () => set({ loading: false, error: null, messages: [] }),
}));
